module.exports = __webpack_public_path__ + "img/Customer-Visits-Visiting-Customers.72e4e7ef.jpg";